<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <page-header>
        <page-button el-type="primary" @click="resetSearch">查询</page-button>
      </page-header>
      <search-condition @search="resetSearch">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="反馈内容"/>
        </template>
      </search-condition>

      <table-list>
        <el-table stripe border :data="dataList" height="100%">
          <el-table-column align="center" label="序号" width="60px" type="index"/>
          <el-table-column label="反馈内容" :align="'center'" min-width="200px">
            <template v-slot="{row}">
              <span v-if="row.msg">{{ row.msg }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="反馈门店" :align="'center'" min-width="200px">
            <template v-slot="{row}">
              <span v-if="row.storeName">{{ row.storeName }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="回复" :align="'center'" prop="reply" min-width="200px" />
          <el-table-column label="反馈时间" :align="'center'" prop="createdTime" min-width="200px" />
          <el-table-column label="状态" :align="'center'" min-width="200px">
            <template v-slot="{row}">
              <span v-if="row.status === 0">待处理</span>
              <span v-if="row.status === 1">已完成</span>
              <span v-if="row.status === 2">已取消</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" :align="'center'" width="150px">
            <template v-slot="{row}">
              <table-button el-type="primary" :disabled="row.status !== 0" @click="viewDetail(row.id)">详情</table-button>
            </template>
          </el-table-column>
        </el-table>
      </table-list>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <el-dialog
        v-model="showDetail"
        title="反馈详情"
        width="50%"
        :close-on-click-modal="false"
        class="feedback-dialog"
        destroy-on-close
    >
      <el-form label-width="100px" class="detail-form">
        <!-- 基础信息卡片 -->
        <div class="info-card">
          <div class="card-header">
            <i class="el-icon-office-building"></i>
            <span>门店基本信息</span>
          </div>
          <div class="card-body">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="门店名称">
                  <span class="form-text">{{ dataDetail.storeName || '暂无' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式">
                  <span class="form-text">{{ dataDetail.storeMobile || '暂无' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 反馈内容卡片 -->
        <div class="info-card">
          <div class="card-header">
            <i class="el-icon-chat-dot-square"></i>
            <span>反馈详情</span>
          </div>
          <div class="card-body">
            <el-form-item label="反馈内容" class="feedback-item">
              <div class="feedback-message">{{ dataDetail.msg || '暂无反馈内容' }}</div>
            </el-form-item>

            <el-form-item label="反馈图片" v-if="dataDetail.attachment && dataDetail.attachment.length">
              <div class="image-list">
                <div v-for="(img, index) in dataDetail.attachment" 
                     :key="index"
                     class="image-wrapper">
                  <el-image
                      :src="img.url"
                      :preview-src-list="previewImageList"
                      class="preview-image"
                      fit="cover"
                  >
                    <template #error>
                      <div class="image-error">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </template>
                  </el-image>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- 回复区域卡片 -->
        <div class="info-card">
          <div class="card-header">
            <i class="el-icon-s-comment"></i>
            <span>回复信息</span>
          </div>
          <div class="card-body">
            <el-form-item class="reply-item">
              <template v-if="dataDetail.reply">
                <div class="reply-content">
                  <i class="el-icon-chat-line-round"></i>
                  {{ dataDetail.reply }}
                </div>
              </template>
              <template v-else>
                <el-input
                    v-model="replyMessage"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入回复内容..."
                    resize="none"
                    class="reply-input"
                />
                <div class="reply-actions">
                  <el-button type="primary" @click="handleReply" :disabled="!replyMessage">
                    <i class="el-icon-s-promotion"></i>
                    提交回复
                  </el-button>
                </div>
              </template>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import PageHeader from "@/components/h5/layout/PageHeader.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import Dictionary from "@/components/h5/Dictionary.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableList from "@/components/h5/layout/TableList.vue";
import miniFeedbackApi from "@/api/main/mini/miniFeedbackApi";

export default {
  name: "",
  components: {
    TableList, TableButton, FormPage, Dictionary,
    PageHeader, SearchCondition, PageButton, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      dataDetail: {},
      showDetail: false,
      replyMessage: '',
      previewImageList: [],
    };
  },
  created() {
  },
  methods: {
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    queryList() {
      miniFeedbackApi.queryList(this.searchInfo).then(res => {
        this.searchInfo.totalCount = res.totalCount;
        this.dataList = res.records;
      })
    },
    viewDetail(id) {
      miniFeedbackApi.findById(id).then(data => {
        try {
          data.attachment = JSON.parse(data.attachment || '[]');
          for (let i = 0; i < data.attachment.length; i++) {
            data.attachment[i].url = process.env.VUE_APP_FILE_URL + data.attachment[i].url;
          }
          this.previewImageList = data.attachment.map(img => img.url);
        } catch (e) {
          data.attachment = [];
          this.previewImageList = [];
        }
        this.dataDetail = data;
        console.log(this.dataDetail.attachment);
        this.showDetail = true;
        this.replyMessage = '';
        console.log(this.dataDetail);
      })
    },
    handleReply() {
      if(!this.replyMessage){
        this.$message.error('回复内容不能为空');
        return;
      }
      miniFeedbackApi.saveReply(
        this.dataDetail.id,
        this.replyMessage
      ).then(() => {
        this.$message.success('回复成功');
        this.queryList();
        this.showDetail = false;
      })
    },
  }
};
</script>

<style lang="scss" scoped>
// 表格样式优化
:deep(.el-table) {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  .el-table__header-wrapper {
    th {
      background-color: #f8faff;
      color: #1f2937;
      font-weight: 600;
      height: 56px;
      border-bottom: 1px solid #e5e7eb;
    }
  }
  
  .el-table__row {
    td {
      padding: 16px 0;
      border-bottom: 1px solid #f0f0f0;
    }

    &:hover {
      td {
        background-color: #f8faff !important;
      }
    }
  }
}

// 对话框样式
.feedback-dialog {
  :deep(.el-dialog) {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.12);

    .el-dialog__header {
      margin: 0;
      padding: 24px;
      background: #fff;
      border-bottom: 1px solid #f0f0f0;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #1f2937;
      }
    }

    .el-dialog__body {
      padding: 24px;
      background: #f8faff;
    }

    .el-dialog__close {
      font-size: 18px;
      color: #64748b;
      
      &:hover {
        color: #1f2937;
      }
    }
  }
}

.detail-form {
  .info-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    margin-bottom: 24px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }

    &:last-child {
      margin-bottom: 0;
    }

    .card-header {
      padding: 16px 24px;
      background: #fff;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      
      i {
        font-size: 18px;
        color: #3b82f6;
        margin-right: 8px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
      }
    }

    .card-body {
      padding: 24px;
    }
  }

  :deep(.el-form-item) {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-form-item__label {
      font-weight: 500;
      color: #64748b;
    }
  }

  .form-text {
    color: #1f2937;
    font-size: 14px;
    line-height: 1.6;
  }

  .feedback-message {
    color: #1f2937;
    line-height: 1.8;
    background: #f8faff;
    padding: 16px 20px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    min-height: 60px;
  }

  .image-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 16px;
    padding: 4px;
  }

  .image-wrapper {
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    background: #f8faff;
    border: 1px solid #e5e7eb;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
      border-color: #3b82f6;
    }
  }

  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8faff;
    color: #94a3b8;
    font-size: 24px;
  }

  .reply-input {
    :deep(.el-textarea__inner) {
      padding: 16px;
      line-height: 1.6;
      border-radius: 8px;
      border-color: #e5e7eb;
      
      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }

  .reply-content {
    padding: 16px 20px;
    background: #f8faff;
    border-radius: 8px;
    color: #1f2937;
    line-height: 1.8;
    border: 1px solid #e5e7eb;
    position: relative;

    i {
      color: #3b82f6;
      margin-right: 8px;
    }
  }

  .reply-actions {
    margin-top: 20px;
    text-align: right;

    .el-button {
      padding: 10px 24px;
      font-weight: 500;
      border-radius: 8px;
      transition: all 0.3s ease;
      
      i {
        margin-right: 6px;
      }
      
      &:not(:disabled) {
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
        }
      }
    }
  }
}
</style>